var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundcloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43457 11.8296V16.705M3.82749 8.71635V18.539M6.37123 18.539V10.4786M8.91497 7.01446V18.539M11.4822 16.1012V18.5616H19.9551C21.8987 18.5616 22.94 16.4222 22.94 14.7277C22.94 12.785 21.4965 10.5735 19.0385 11.0975V10.8937C19.2829 7.71634 16.1069 4.55829 11.4822 5.66352V16.1012Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.92d4f7b3461d4431024780167f9d31d6.svg";
export { ForwardRef as ReactComponent };